import React from 'react';
import iconCard from 'src/assets/card_outline.svg';
import iconDocumentSearch from 'src/assets/search_document_outline.svg';
import iconGift from 'src/assets/gift.svg';
import iconUserGroup from 'src/assets/user_group.svg';
import './style.scoped.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import policySt from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import {
  PATH,
  ON_TO_OFF_TRACKING,
  ON_TO_OFF_STEP,
  ON_TO_OFF,
  CAMPAIGN_CODES,
  LOCAL_ACCOUNT_TRACKING,
  LOCAL_ACCOUNT_STEP,
  LOCAL_ACCOUNT,
  ON_TO_OFF_ACTION_TYPE,
} from 'src/constants';
import { featureInDevelopment, gaTrackingAndLogAction  } from 'src/utils';

const data = [{
    id: 1,
    name: 'search_insurance_contract',
    icon: iconDocumentSearch,
    bgColor: 'var(--color-attention)',
    path: PATH.MY_POLICY
  },
  {
    id: 2,
    name: 'pay_insurance_fee',
    icon: iconCard,
    bgColor: 'var(--color-primary)',
    path: PATH.ONLINE_PAYMENT
  },
  {
    id: 3,
    name: 'special_offers_label',
    icon: iconGift,
    bgColor: 'var(--color-secondary)',
    path: null,
  },
  {
    id: 4,
    name: 'local_account',
    icon: iconUserGroup,
    bgColor: 'var(--color-error)',
    path: null,
  },
  {
    id: 5,
    name: 'payment_online',
    icon: iconUserGroup,
    bgColor: 'var(--color-error)',
    path: PATH.PAYMENT_ONLINE,
  },
];


const FunctionBlockObserver = observer(({ policyStore }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const _renderItem = (item) => {
    return (
      <div className={`functionItem`} key={item.id} onClick={() => {
        switch(item.path){
          case PATH.MY_POLICY: {
            policyStore.getListAllPolicy(history, "HOME");
            break;
          }
          case PATH.ONLINE_PAYMENT: {
            history.push(item.path);
            break;
          }
          case PATH.PAYMENT_ONLINE: {
            history.push(item.path);
            break;
          }
          default: {
            featureInDevelopment();
            break;
          }
        }

      }}>
        <div
          className="functionImageItem"
          style={{ backgroundColor: item.bgColor }}
        >
          <img src={item.icon} className="m-auto" />
        </div>
        <div className="smallTitle functionText">{t(item.name)}</div>
      </div>
    );
  };

  return (
    <div className={'grid grid-flow-row grid-cols-2 grid-rows-2 gap-4'}>
      {data.map((item) => {
        if(window?.local?.hostname?.include("mbal-portal.mbageas.org") && item?.path === PATH.PAYMENT_ONLINE) {
          return
        }
        return _renderItem(item)
      })}
    </div>
  );
});

const FunctionBlock = () => <FunctionBlockObserver policyStore={policySt} />;
export default FunctionBlock;
